<template>
  <div
    class="tw:flex tw:flex-col tw:w-full tw:min-h-screen-minus-header-and-footer"
  >
    <RIRates />
  </div>
</template>
<script setup lang="ts">
import RIRates from '@/components/rateInsights/RIRates.vue'
</script>
